import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { PHONES, WHATSAPP_PRIMARY } from "@/lib/brand";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-24 right-5 z-40 flex flex-col gap-3 sm:bottom-5 sm:left-5 sm:right-auto">
      <a
        href={`https://wa.me/${WHATSAPP_PRIMARY}?text=${encodeURIComponent("Hola Rosas Cleaning, me gustaría una cotización 💖")}`}
        target="_blank"
        rel="noreferrer"
        data-testid="float-whatsapp"
        className="group w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-white flex items-center justify-center shadow-2xl shadow-black/40 transition-all hover:scale-110"
        aria-label="WhatsApp"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
      <a
        href={`tel:+1${PHONES[0].replace(/-/g, "")}`}
        data-testid="float-call"
        className="group w-14 h-14 rounded-full bg-[#EC008C] hover:bg-[#FF1F87] text-white flex items-center justify-center shadow-2xl shadow-[#EC008C]/40 transition-all hover:scale-110"
        aria-label="Call"
      >
        <Phone className="w-6 h-6" />
      </a>
    </div>
  );
}
